export const OHL = {
    name: 'DV 155/2 TS NOVI PAZAR 2 - TS VALAČ',
    voltage: '110',
    regionCode: 'BET',
    stanice: [{name: 'VALAČ', position: {lat: 42.9281, lng: 20.8234}}],
    stubovi: [
        { index: 1, name: 'P-03', lat: 43.046 , lng: 20.68, sys: 1, portal: true},
        { index: 2, name: '134(1u)', lat: 43.0465 , lng: 20.6776, sys: 1},
        { index: 3, name: '133(2u)', lat: 43.0475 , lng: 20.6739, sys: 1},
        { index: 4, name: '132(3u)', lat: 43.0478 , lng: 20.6728, sys: 1},
        { index: 5, name: '131(4u)', lat: 43.0485 , lng: 20.67, sys: 1},
        { index: 6, name: '130(5u)', lat: 43.049 , lng: 20.6679, sys: 1},
        { index: 7, name: '129(6u)', lat: 43.0496 , lng: 20.6654, sys: 1},
        { index: 8, name: '128(7u)', lat: 43.0499 , lng: 20.6647, sys: 1},
        { index: 9, name: '127(8u)', lat: 43.0508 , lng: 20.6625, sys: 1},
        { index: 10, name: '126(9u)', lat: 43.0513 , lng: 20.6613, sys: 1},
        { index: 11, name: '125(10u)', lat: 43.0522 , lng: 20.659, sys: 1},
        { index: 12, name: '124(11u)', lat: 43.0527 , lng: 20.6579, sys: 1},
        { index: 13, name: '123(109)', lat: 43.0536 , lng: 20.6556, sys: 1},
        { index: 14, name: '122(108)', lat: 43.0538 , lng: 20.6552, sys: 1},
        { index: 15, name: '121(107)', lat: 43.0544 , lng: 20.6537, sys: 1},
        { index: 16, name: '120(106)', lat: 43.0561 , lng: 20.6495, sys: 1},
        { index: 17, name: '119(105)', lat: 43.0581 , lng: 20.6444, sys: 1},
        { index: 18, name: '118(104)', lat: 43.0593 , lng: 20.6416, sys: 1},
        { index: 19, name: '117(103)', lat: 43.06 , lng: 20.6396, sys: 1},
        { index: 20, name: '116(102)', lat: 43.0611 , lng: 20.6369, sys: 1},
        { index: 21, name: '115(101)', lat: 43.062 , lng: 20.6347, sys: 1},
        { index: 22, name: '114(100)', lat: 43.0632 , lng: 20.6313, sys: 1},
        { index: 23, name: '113(99)', lat: 43.0641 , lng: 20.6291, sys: 1},
        { index: 24, name: '112(98)', lat: 43.0657 , lng: 20.6251, sys: 1},
        { index: 25, name: '111(97)', lat: 43.0671 , lng: 20.6216, sys: 1},
        { index: 26, name: '110(96)', lat: 43.0681 , lng: 20.6189, sys: 1},
        { index: 27, name: '109(95)', lat: 43.0688 , lng: 20.6172, sys: 1},
        { index: 28, name: '108(94)', lat: 43.0729 , lng: 20.6132, sys: 1},
        { index: 29, name: '107(93)', lat: 43.076 , lng: 20.6101, sys: 1},
        { index: 30, name: '106(92)', lat: 43.0784 , lng: 20.6077, sys: 1},
        { index: 31, name: '105(91)', lat: 43.0808 , lng: 20.6053, sys: 1},
        { index: 32, name: '104(90)', lat: 43.0838 , lng: 20.6024, sys: 1},
        { index: 33, name: '103(89)', lat: 43.0856 , lng: 20.6006, sys: 1},
        { index: 34, name: '102(88)', lat: 43.0886 , lng: 20.5976, sys: 1},
        { index: 35, name: '101(87)', lat: 43.0908 , lng: 20.5955, sys: 1},
        { index: 36, name: '100(86)', lat: 43.093 , lng: 20.5933, sys: 1},
        { index: 37, name: '99(85)', lat: 43.0949 , lng: 20.5914, sys: 1},
        { index: 38, name: '98(84)', lat: 43.0993 , lng: 20.587, sys: 1},
        { index: 39, name: '97(83)', lat: 43.1002 , lng: 20.5862, sys: 1},
        { index: 40, name: '96(82)', lat: 43.1035 , lng: 20.5839, sys: 1},
        { index: 41, name: '95(81)', lat: 43.1049 , lng: 20.5828, sys: 1},
        { index: 42, name: '94(80)', lat: 43.1088 , lng: 20.5801, sys: 1},
        { index: 43, name: '93(79)', lat: 43.1109 , lng: 20.5786, sys: 1},
        { index: 44, name: '92(78)', lat: 43.1122 , lng: 20.5777, sys: 1},
        { index: 45, name: '91(77)', lat: 43.1133 , lng: 20.577, sys: 1},
        { index: 46, name: '90(76)', lat: 43.1147 , lng: 20.576, sys: 1},
        { index: 47, name: '89(75)', lat: 43.1163 , lng: 20.5736, sys: 1},
        { index: 48, name: '88(74)', lat: 43.1189 , lng: 20.5695, sys: 1},
        { index: 49, name: '87(73)', lat: 43.1202 , lng: 20.5674, sys: 1},
        { index: 50, name: '86(72)', lat: 43.1223 , lng: 20.5642, sys: 1},
        { index: 51, name: '85(71)', lat: 43.124 , lng: 20.563, sys: 1},
        { index: 52, name: '84(70)', lat: 43.1266 , lng: 20.5612, sys: 1},
        { index: 53, name: '83(69)', lat: 43.1289 , lng: 20.5595, sys: 1},
        { index: 54, name: '82(68)', lat: 43.1305 , lng: 20.5585, sys: 1},
        { index: 55, name: '81(67)', lat: 43.1343 , lng: 20.5557, sys: 1},
        { index: 56, name: '88(66)', lat: 43.1357 , lng: 20.5548, sys: 1},
        { index: 57, name: '79(65)', lat: 43.1387 , lng: 20.5526, sys: 1},
        { index: 58, name: '78(64 B)', lat: 43.1412 , lng: 20.5509, sys: 1},
        { index: 59, name: '77(64 A)', lat: 43.1426 , lng: 20.5499, sys: 1},
        { index: 60, name: '76(64)', lat: 43.1427 , lng: 20.5462, sys: 1},
        { index: 61, name: '75(63)', lat: 43.1428 , lng: 20.5445, sys: 1},
        { index: 62, name: '74(62 B)', lat: 43.1429 , lng: 20.5431, sys: 1},
        { index: 63, name: '73(62 A)', lat: 43.1441 , lng: 20.54, sys: 1},
        { index: 64, name: '72(62)', lat: 43.1452 , lng: 20.537, sys: 1},
        { index: 65, name: '71(61 A)', lat: 43.1454 , lng: 20.5356, sys: 1},
        { index: 66, name: '70(61)', lat: 43.1459 , lng: 20.5314, sys: 1},
        { index: 67, name: '69(60 A)', lat: 43.1461 , lng: 20.53, sys: 1},
        { index: 68, name: '68(60)', lat: 43.1469 , lng: 20.5294, sys: 1},
        { index: 69, name: '67(59 A)', lat: 43.1485 , lng: 20.5281, sys: 1},
        { index: 70, name: '66(59)', lat: 43.1488 , lng: 20.5283, sys: 1},
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
    ],
    rasponi: [
        { name: 'P-03 - 134(1u)', position: [{ lat: 43.046 , lng: 20.68 }, { lat: 43.0465 , lng: 20.6776 }] },
        { name: '134(1u) - 133(2u)', position: [{ lat: 43.0465 , lng: 20.6776 }, { lat: 43.0475 , lng: 20.6739 }] },
        { name: '133(2u) - 132(3u)', position: [{ lat: 43.0475 , lng: 20.6739 }, { lat: 43.0478 , lng: 20.6728 }] },
        { name: '132(3u) - 131(4u)', position: [{ lat: 43.0478 , lng: 20.6728 }, { lat: 43.0485 , lng: 20.67 }] },
        { name: '131(4u) - 130(5u)', position: [{ lat: 43.0485 , lng: 20.67 }, { lat: 43.049 , lng: 20.6679 }] },
        { name: '130(5u) - 129(6u)', position: [{ lat: 43.049 , lng: 20.6679 }, { lat: 43.0496 , lng: 20.6654 }] },
        { name: '129(6u) - 128(7u)', position: [{ lat: 43.0496 , lng: 20.6654 }, { lat: 43.0499 , lng: 20.6647 }] },
        { name: '128(7u) - 127(8u)', position: [{ lat: 43.0499 , lng: 20.6647 }, { lat: 43.0508 , lng: 20.6625 }] },
        { name: '127(8u) - 126(9u)', position: [{ lat: 43.0508 , lng: 20.6625 }, { lat: 43.0513 , lng: 20.6613 }] },
        { name: '126(9u) - 125(10u)', position: [{ lat: 43.0513 , lng: 20.6613 }, { lat: 43.0522 , lng: 20.659 }] },
        { name: '125(10u) - 124(11u)', position: [{ lat: 43.0522 , lng: 20.659 }, { lat: 43.0527 , lng: 20.6579 }] },
        { name: '124(11u) - 123(109)', position: [{ lat: 43.0527 , lng: 20.6579 }, { lat: 43.0536 , lng: 20.6556 }] },
        { name: '123(109) - 122(108)', position: [{ lat: 43.0536 , lng: 20.6556 }, { lat: 43.0538 , lng: 20.6552 }] },
        { name: '122(108) - 121(107)', position: [{ lat: 43.0538 , lng: 20.6552 }, { lat: 43.0544 , lng: 20.6537 }] },
        { name: '121(107) - 120(106)', position: [{ lat: 43.0544 , lng: 20.6537 }, { lat: 43.0561 , lng: 20.6495 }] },
        { name: '120(106) - 119(105)', position: [{ lat: 43.0561 , lng: 20.6495 }, { lat: 43.0581 , lng: 20.6444 }] },
        { name: '119(105) - 118(104)', position: [{ lat: 43.0581 , lng: 20.6444 }, { lat: 43.0593 , lng: 20.6416 }] },
        { name: '118(104) - 117(103)', position: [{ lat: 43.0593 , lng: 20.6416 }, { lat: 43.06 , lng: 20.6396 }] },
        { name: '117(103) - 116(102)', position: [{ lat: 43.06 , lng: 20.6396 }, { lat: 43.0611 , lng: 20.6369 }] },
        { name: '116(102) - 115(101)', position: [{ lat: 43.0611 , lng: 20.6369 }, { lat: 43.062 , lng: 20.6347 }] },
        { name: '115(101) - 114(100)', position: [{ lat: 43.062 , lng: 20.6347 }, { lat: 43.0632 , lng: 20.6313 }] },
        { name: '114(100) - 113(99)', position: [{ lat: 43.0632 , lng: 20.6313 }, { lat: 43.0641 , lng: 20.6291 }] },
        { name: '113(99) - 112(98)', position: [{ lat: 43.0641 , lng: 20.6291 }, { lat: 43.0657 , lng: 20.6251 }] },
        { name: '112(98) - 111(97)', position: [{ lat: 43.0657 , lng: 20.6251 }, { lat: 43.0671 , lng: 20.6216 }] },
        { name: '111(97) - 110(96)', position: [{ lat: 43.0671 , lng: 20.6216 }, { lat: 43.0681 , lng: 20.6189 }] },
        { name: '110(96) - 109(95)', position: [{ lat: 43.0681 , lng: 20.6189 }, { lat: 43.0688 , lng: 20.6172 }] },
        { name: '109(95) - 108(94)', position: [{ lat: 43.0688 , lng: 20.6172 }, { lat: 43.0729 , lng: 20.6132 }] },
        { name: '108(94) - 107(93)', position: [{ lat: 43.0729 , lng: 20.6132 }, { lat: 43.076 , lng: 20.6101 }] },
        { name: '107(93) - 106(92)', position: [{ lat: 43.076 , lng: 20.6101 }, { lat: 43.0784 , lng: 20.6077 }] },
        { name: '106(92) - 105(91)', position: [{ lat: 43.0784 , lng: 20.6077 }, { lat: 43.0808 , lng: 20.6053 }] },
        { name: '105(91) - 104(90)', position: [{ lat: 43.0808 , lng: 20.6053 }, { lat: 43.0838 , lng: 20.6024 }] },
        { name: '104(90) - 103(89)', position: [{ lat: 43.0838 , lng: 20.6024 }, { lat: 43.0856 , lng: 20.6006 }] },
        { name: '103(89) - 102(88)', position: [{ lat: 43.0856 , lng: 20.6006 }, { lat: 43.0886 , lng: 20.5976 }] },
        { name: '102(88) - 101(87)', position: [{ lat: 43.0886 , lng: 20.5976 }, { lat: 43.0908 , lng: 20.5955 }] },
        { name: '101(87) - 100(86)', position: [{ lat: 43.0908 , lng: 20.5955 }, { lat: 43.093 , lng: 20.5933 }] },
        { name: '100(86) - 99(85)', position: [{ lat: 43.093 , lng: 20.5933 }, { lat: 43.0949 , lng: 20.5914 }] },
        { name: '99(85) - 98(84)', position: [{ lat: 43.0949 , lng: 20.5914 }, { lat: 43.0993 , lng: 20.587 }] },
        { name: '98(84) - 97(83)', position: [{ lat: 43.0993 , lng: 20.587 }, { lat: 43.1002 , lng: 20.5862 }] },
        { name: '97(83) - 96(82)', position: [{ lat: 43.1002 , lng: 20.5862 }, { lat: 43.1035 , lng: 20.5839 }] },
        { name: '96(82) - 95(81)', position: [{ lat: 43.1035 , lng: 20.5839 }, { lat: 43.1049 , lng: 20.5828 }] },
        { name: '95(81) - 94(80)', position: [{ lat: 43.1049 , lng: 20.5828 }, { lat: 43.1088 , lng: 20.5801 }] },
        { name: '94(80) - 93(79)', position: [{ lat: 43.1088 , lng: 20.5801 }, { lat: 43.1109 , lng: 20.5786 }] },
        { name: '93(79) - 92(78)', position: [{ lat: 43.1109 , lng: 20.5786 }, { lat: 43.1122 , lng: 20.5777 }] },
        { name: '92(78) - 91(77)', position: [{ lat: 43.1122 , lng: 20.5777 }, { lat: 43.1133 , lng: 20.577 }] },
        { name: '91(77) - 90(76)', position: [{ lat: 43.1133 , lng: 20.577 }, { lat: 43.1147 , lng: 20.576 }] },
        { name: '90(76) - 89(75)', position: [{ lat: 43.1147 , lng: 20.576 }, { lat: 43.1163 , lng: 20.5736 }] },
        { name: '89(75) - 88(74)', position: [{ lat: 43.1163 , lng: 20.5736 }, { lat: 43.1189 , lng: 20.5695 }] },
        { name: '88(74) - 87(73)', position: [{ lat: 43.1189 , lng: 20.5695 }, { lat: 43.1202 , lng: 20.5674 }] },
        { name: '87(73) - 86(72)', position: [{ lat: 43.1202 , lng: 20.5674 }, { lat: 43.1223 , lng: 20.5642 }] },
        { name: '86(72) - 85(71)', position: [{ lat: 43.1223 , lng: 20.5642 }, { lat: 43.124 , lng: 20.563 }] },
        { name: '85(71) - 84(70)', position: [{ lat: 43.124 , lng: 20.563 }, { lat: 43.1266 , lng: 20.5612 }] },
        { name: '84(70) - 83(69)', position: [{ lat: 43.1266 , lng: 20.5612 }, { lat: 43.1289 , lng: 20.5595 }] },
        { name: '83(69) - 82(68)', position: [{ lat: 43.1289 , lng: 20.5595 }, { lat: 43.1305 , lng: 20.5585 }] },
        { name: '82(68) - 81(67)', position: [{ lat: 43.1305 , lng: 20.5585 }, { lat: 43.1343 , lng: 20.5557 }] },
        { name: '81(67) - 88(66)', position: [{ lat: 43.1343 , lng: 20.5557 }, { lat: 43.1357 , lng: 20.5548 }] },
        { name: '88(66) - 79(65)', position: [{ lat: 43.1357 , lng: 20.5548 }, { lat: 43.1387 , lng: 20.5526 }] },
        { name: '79(65) - 78(64 B)', position: [{ lat: 43.1387 , lng: 20.5526 }, { lat: 43.1412 , lng: 20.5509 }] },
        { name: '78(64 B) - 77(64 A)', position: [{ lat: 43.1412 , lng: 20.5509 }, { lat: 43.1426 , lng: 20.5499 }] },
        { name: '77(64 A) - 76(64)', position: [{ lat: 43.1426 , lng: 20.5499 }, { lat: 43.1427 , lng: 20.5462 }] },
        { name: '76(64) - 75(63)', position: [{ lat: 43.1427 , lng: 20.5462 }, { lat: 43.1428 , lng: 20.5445 }] },
        { name: '75(63) - 74(62 B)', position: [{ lat: 43.1428 , lng: 20.5445 }, { lat: 43.1429 , lng: 20.5431 }] },
        { name: '74(62 B) - 73(62 A)', position: [{ lat: 43.1429 , lng: 20.5431 }, { lat: 43.1441 , lng: 20.54 }] },
        { name: '73(62 A) - 72(62)', position: [{ lat: 43.1441 , lng: 20.54 }, { lat: 43.1452 , lng: 20.537 }] },
        { name: '72(62) - 71(61 A)', position: [{ lat: 43.1452 , lng: 20.537 }, { lat: 43.1454 , lng: 20.5356 }] },
        { name: '71(61 A) - 70(61)', position: [{ lat: 43.1454 , lng: 20.5356 }, { lat: 43.1459 , lng: 20.5314 }] },
        { name: '70(61) - 69(60 A)', position: [{ lat: 43.1459 , lng: 20.5314 }, { lat: 43.1461 , lng: 20.53 }] },
        { name: '69(60 A) - 68(60)', position: [{ lat: 43.1461 , lng: 20.53 }, { lat: 43.1469 , lng: 20.5294 }] },
        { name: '68(60) - 67(59 A)', position: [{ lat: 43.1469 , lng: 20.5294 }, { lat: 43.1485 , lng: 20.5281 }] },
        { name: '67(59 A) - 66(59)', position: [{ lat: 43.1485 , lng: 20.5281 }, { lat: 43.1488 , lng: 20.5283 }] }
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
        // NULL
    ]
}
